// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1612":"6265e9f83492fafb","2179":"8e8a49534c884ecb"}[chunkId] + ".js";
};